import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentService } from '../../../../shared/environment.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  baseUrl = `${this.env.apiUrl}/login`;
  headers = this.env.getLoginHeaders();
  email:any
  constructor(
    public http: HttpClient, public env: EnvironmentService
  ) { }
  userLogin(params: any) {
    let url = `login`;
    return this.env.postWithoutToken(url,params); 
  }

  refreshToken(refreshToken:any){
    let url = `refresh-token`;
    return this.env.post(url, refreshToken);
  }

  requestOtp(param:any){
    let url = `otp/send?email=${param}`;
    return this.env.postWithoutToken(url);
  }

  verifyOtp(param:any){
    let url = `otp/verify?email=${param.email}&otp=${param.otp}`;
    return this.env.postWithoutToken(url);
  }

  resetPassword(params:any){
    let url = `reset-password`;
    return this.env.patch(url,params);
  }
}
